import { useState } from 'react';
import { useAsyncTaskHandler } from 'src/common/utils/useAsyncTaskHandler';
import { updateEmployeeGroupsSelections } from 'src/components/enterprise/features/Employee/EmployeeDetailsPage/components/EmployeeGroupsWrapper/api/updateEmployeeGroupsSelectionsAPI';
import { transformIdsToPayload } from 'src/components/enterprise/features/Employee/EmployeeDetailsPage/components/EmployeeGroupsWrapper/employeeGroupsSelection.utils';

export interface UseUpdateEmployeeGroupsSelectionsProps {
  corpId: string;
  employeeId: string;
  onSuccess?: () => Promise<void>;
}

export interface UseUpdateEmployeeGroupsSelectionsReturn {
  updateSelections: (selections: string[]) => Promise<void>;
  isSaving: boolean;
}

export function useUpdateEmployeeGroupsSelections({
  corpId,
  employeeId,
  onSuccess,
}: UseUpdateEmployeeGroupsSelectionsProps): UseUpdateEmployeeGroupsSelectionsReturn {
  const [isSaving, setIsSaving] = useState(false);

  const { startAsyncTask } = useAsyncTaskHandler({
    onSuccess: handleSuccess,
    onError: handleError,
  });

  async function updateSelections(selections: string[]): Promise<void> {
    setIsSaving(true);

    await startAsyncTask(() => {
      const payload = transformIdsToPayload(selections);
      return updateEmployeeGroupsSelections(corpId, employeeId, payload);
    });
  }

  async function handleSuccess(): Promise<void> {
    await onSuccess?.();
    setIsSaving(false);
  }

  async function handleError(): Promise<void> {
    setIsSaving(false);
  }

  return {
    updateSelections,
    isSaving,
  };
}
